import React from "react";
import axios from "axios";
import { Routes, Route, Link, useSearchParams } from "react-router-dom";

function NotFound() {
  return <h1>404 Not Found</h1>;
}

export default NotFound;
